export default [
    {
		path: '/events',
		name: 'Events',
		meta: { 
			requiresAuth: true,
			section: 'events'
		},
		component: () => import('@/views/event/Events'),
    },    
    {
		path: '/events/:id',
		name: 'EventsDetail',
		meta: { 
			requiresAuth: true,
			section: 'events'
		},
		component: () => import('@/views/event/EventDetail'),
    },    
]

